export class ProductDetailItem {
  public Id: string;

  public Name: string;

  public Summary: string;

  public Content: string;

  public ImageUrl: string;

  public CallToActionUrl: string;

  public CallToActionText: string;

  public Tag: string;

  constructor(id:string,
    name:string,
    summary:string,
    content:string,
    imageUrl:string,
    callToActionUrl:string,
    callToActionText: string,
    tag:string) {
    this.Id = id;
    this.Name = name;
    this.Summary = summary;
    this.Content = content;
    this.ImageUrl = imageUrl;
    this.CallToActionUrl = callToActionUrl;
    this.CallToActionText = callToActionText;
    this.Tag = tag;
  }
}
